import { useQuery, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import {
  fetchMatches,
  type FetchMatchesParams,
  type MatchesListData,
  type MatchesResponse,
} from '@/lib/network';

export const MATCHES_QUERY_KEY_PREFIX = ['matches'] as const;

export const getMatchesQueryKey = (params?: FetchMatchesParams) =>
  [...MATCHES_QUERY_KEY_PREFIX, params ?? {}] as const;

export type UseFetchMatchesOptions = Omit<
  UseQueryOptions<MatchesResponse, Error, MatchesListData>,
  'queryKey' | 'queryFn'
>;

export const useFetchMatches = (
  params?: FetchMatchesParams,
  options?: UseFetchMatchesOptions
): UseQueryResult<MatchesListData, Error> => {
  return useQuery<MatchesResponse, Error, MatchesListData>({
    queryKey: getMatchesQueryKey(params),
    queryFn: () => fetchMatches(params),
    select: response => response.data,
    // Matches the 30s Redis TTL on the match list, so a returning player is not
    // served a five-minute-old payload of scores and odds on focus.
    staleTime: 30 * 1000,
    gcTime: 10 * 60 * 1000,
    ...options,
  });
};
